import { ExternalLinkIcon } from 'lucide-react'

import { SplitsLink } from '~/components/Link'
import { useBridgeReceiptUrl } from '~/components/txn-display/state-change/hooks/useBridgeReceiptUrl'
import { useShowBridgeFooter } from '~/components/txn-display/state-change/hooks/useShowBridgeFooter'
import { OrgRegularTransaction, PublicRegularTransaction } from '~/types'

export const PastStateChangeFooter = ({
  transaction,
}: {
  transaction: OrgRegularTransaction | PublicRegularTransaction
}) => {
  const showFooter = useShowBridgeFooter(transaction)
  const bridgeReceiptUrl = useBridgeReceiptUrl(transaction)

  // For bridge transactions that don't have the full metadata, we show a best effort approximation of the bridge transaction with a link to the relay receipt.
  if (showFooter && bridgeReceiptUrl) {
    return (
      <span>
        This is a best effort approximation of the bridge transaction. You can
        view the full transaction receipt on{' '}
        <SplitsLink
          path={bridgeReceiptUrl}
          target="tab"
          className="inline-flex items-center gap-0.5 hover:underline"
        >
          Relay
          <ExternalLinkIcon className="size-2.5" />
        </SplitsLink>
        .
      </span>
    )
  }

  return null
}
